/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SidebarNavigationGroup from "../../molecules/nav/side/SidebarNavigationGroup";
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {pageLoad, showAlerts} from "../../../../actions/my-puratos/navigation.action";
import {withErrorBoundary} from "../../hoc/withErrorBoundary";
import {withI18N} from "../../hoc/withI18N";
import {compose} from "redux";
import {translate} from "../../../../api/utils/i18nHelper";


class SideNavigation extends Component {

    state = {
        navMobileVisible: false,
    };

    toggleMobileNav = () => {
        this.setState({
            navMobileVisible: !this.state.navMobileVisible
        })
    };

    onRouteChanged = () => {
        const {language} = this.props;

        if (language) this.onLoadGTMEvent();
    };

    onLoadGTMEvent() {
        const {location, language} = this.props;
        const path = location.pathname;
        let pageName = path.slice(1);

        this.props.pageLoad({
            title: pageName,
            language,
        });
    }

    componentDidMount() {
        this.onRouteChanged();
    }

    componentDidUpdate(prevProps) {
        const {location, mapping, language} = this.props;
        if (mapping !== prevProps.mapping || location.pathname !== prevProps.location.pathname) {
            this.onRouteChanged();
        }

        if (language && language !== prevProps.language) {
            this.onLoadGTMEvent();
        }
    }

    render() {
        const {data, i18n} = this.props;
        const {navMobileVisible} = this.state;

        return <div className="p-frame__left my-puratos-navigation">
                <div className="p-nav-side-toggle" onClick={this.toggleMobileNav}>
                    <div className="p-nav-side-toggle__title">
                        {translate(i18n, "MyPuratos")}
                    </div>
                    <div className={"p-nav-side-toggle__icon" + (navMobileVisible ? ' active' : '')}>
                        <span className="svg-plus-sign-black-circle"/>
                    </div>
                </div>
                <div className={`p-nav-side js-nav-side ${this.state.navMobileVisible ? "is-visible" : ""}`}>
                    {data.sections.map(section =>
                        <SidebarNavigationGroup
                            key={section.type}
                            title={section.title}
                            items={section.items}
                            onRouteChange={this.toggleMobileNav}
                        />
                    )}
                </div>
            </div>;
    }
}

SideNavigation.propTypes = {
    data: PropTypes.object,
    location: PropTypes.object,
};
SideNavigation.defaultProps = {};

const mapStateToProps = (state) => ({
    data: state.myPuratos_navigation.sidebar,
    mapping: state.myPuratos_dashboard.mapping,
    language: state.myPuratos_navigation.language
});
const mapDispatchToProps = {
    showAlerts,
    pageLoad
};

//export default withErrorBoundary(compose(connect(mapStateToProps, mapDispatchToProps), withI18N)(withRouter(SideNavigation)));
export default withErrorBoundary(withRouter(connect(mapStateToProps, mapDispatchToProps)(SideNavigation)));

